import React, { useEffect, useId, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
interface ModalProps {
  open: boolean;
  title: string;
  description?: string;
  onClose: () => void;
  footer: React.ReactNode;
  children: React.ReactNode;
}
export function Modal({
  open,
  title,
  description,
  onClose,
  footer,
  children
}: ModalProps) {
  const titleId = useId();
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  useEffect(() => {
    if (!open) return;
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onCloseRef.current();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [open]);
  return <AnimatePresence data-id="element-825" data-mp="251w65qbxzfq5">
      {open && <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.15,
      ease: 'easeOut'
    }} data-id="element-826" data-mp="3ugtyembv5og5">
          <div className="absolute inset-0 bg-[#080707]/60" onClick={onClose} aria-hidden="true" data-id="element-827" data-mp="2x2qowz6rmzx2" />
          <motion.div role="dialog" aria-modal="true" aria-labelledby={titleId} initial={{
        opacity: 0,
        scale: 0.96,
        y: 8
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative flex max-h-[90vh] w-full max-w-[560px] flex-col overflow-hidden rounded bg-white shadow-2xl" data-id="element-828" data-mp="2t15hhtd03du9">
            <header className="border-b border-sf-border px-6 py-4 text-center" data-id="element-829" data-mp="2o5gefg1rvet7">
              <h2 id={titleId} className="text-xl text-sf-text" data-id="element-830" data-mp="2j4amvljulxl9">
                {title}
              </h2>
              {description && <p className="mt-1 text-[13px] text-sf-weak" data-id="element-831" data-mp="3g0saydi0e9w">{description}</p>}
            </header>
            <div className="overflow-y-auto px-6 py-5" data-id="element-832" data-mp="3ujz4dxec24eo">{children}</div>
            <footer className="flex justify-end gap-2 border-t border-sf-border bg-sf-bg px-6 py-3" data-id="element-833" data-mp="6er5zp6s5t4m">{footer}</footer>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}